<footer class="bg-light border-top container-fluid">
  <div class="p-2">
    <ul class="list-inline text-end m-0" style="font-size: 12px">
      <li class="list-inline-item pe-2">
        <label for="default-year-select" class="me-1">Standardjahr:</label>
        <select
          id="default-year-select"
          class="form-select form-select-sm d-inline-block w-auto footer-year-select"
          [ngModel]="defaultYearService.selectedYear()"
          (ngModelChange)="defaultYearService.setSelectedYear(+$event)"
        >
          @for (year of defaultYearService.availableYears; track year) {
            <option [ngValue]="year">{{ year }}</option>
          }
        </select>
      </li>
      <li class="list-inline-item pe-2">Copyright &copy; {{ currentYear }} dbConn GmbH</li>
      <li class="list-inline-item pe-2">
        @if (buildInfo) {
          Build-Datum: {{ buildInfo.buildTime | date: 'dd.MM.yyyy' }} | Version: {{ buildInfo.buildVersion }}
        }
      </li>
    </ul>
  </div>
</footer>
